module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Here goes home page content")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-671feb7d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Test/index.vue
// module id = 875
// module chunks = 76